<div *ngIf="loading">
  <sv-product-card-loader></sv-product-card-loader>
</div>

<h2 *ngIf="featured && groupedProducts && groupedProducts.length">
  <span *ngIf="generalService.translationMode === true"> (H001) </span>
  {{ "HOME.H001.value" | translate }}
</h2>

<div *ngIf="searchPage && groupedProducts && groupedProducts.length && selectedDisplayGroup">
  <h2>
    <span *ngIf="generalService.debugMode"> [ name ] </span>
    {{ selectedDisplayGroup.name }}
  </h2>
  <p *ngIf="generalService.debugMode">
    <span> [ desc ] </span>
    {{ selectedDisplayGroup.desc }}
  </p>
  <div class="extra-debug-info" *ngIf="generalService.debugMode">
    <br />
    <b> Extra debug info : </b> <br />
    <small>
      <pre> {{ selectedDisplayGroup | json }} </pre>
    </small>
  </div>
</div>

<h2 *ngIf="noProducts">
  <span *ngIf="generalService.translationMode === true"> (P001) </span>
  {{ "PRODUCT.P001.value" | translate }}
</h2>


<div infinite-scroll (scrolled)="!featured && onScrollDown()" *ngIf="groupedProducts && groupedProducts.length">
  <ng-container *ngFor="let group of groupedProducts">
    <!-- Only display vendors if shop-in-mode -->
    <h2 *ngIf="groupedProducts.length > 1">{{ group.vendor }}</h2>
    <div class="c-productsList">
      <ng-template ngFor let-product [ngForOf]="group.products" let-i="index">
        <ng-template [ngIf]="product.C000 !== detailProductId">
          <sv-product-card [data]="product" [loggedIn]="loggedIn" class="c-productsList__item"></sv-product-card>
        </ng-template>
      </ng-template>

      <div class="c-productsList__item c-productsList__item--empty"></div>
      <div class="c-productsList__item c-productsList__item--empty"></div>
      <div class="c-productsList__item c-productsList__item--empty"></div>
      <div class="c-productsList__item c-productsList__item--empty"></div>
      <div class="c-productsList__item c-productsList__item--empty"></div>
      <div class="c-productsList__item c-productsList__item--empty"></div>
      <div class="c-productsList__item c-productsList__item--empty"></div>
      <div class="c-productsList__item c-productsList__item--empty"></div>
      <div class="c-productsList__item c-productsList__item--empty"></div>
      <div class="c-productsList__item c-productsList__item--empty"></div>
      <div class="c-productsList__item c-productsList__item--empty"></div>
      <div class="c-productsList__item c-productsList__item--empty"></div>
    </div>
  </ng-container>
</div>